export default [
  {
    orderID: "125452",
    deliveryPartner: "BlueDart",
    awbNo: "1254",
currentStatus: "Shpment Booked",
custdetails: "Mahesh Kudale",
destination: "Nahur",
pickupDate: "01/12/2012",
    expectedDelivery: "11/12/2021",
    enrouteDays: "5",
    dateAdded: "01/02/2021"
  },
  {
    orderID: "125452",
    deliveryPartner: "BlueDart",
    awbNo: "1254",
currentStatus: "Delivered",
custdetails: "Mahesh Kudale",
destination: "Nahur",
pickupDate: "01/12/2012",
    expectedDelivery: "11/12/2021",
    enrouteDays: "5",
    dateAdded: "01/02/2021"
  
  },
  {
    orderID: "125452",
    deliveryPartner: "BlueDart",
    awbNo: "1254",
currentStatus: "In Transit",
custdetails: "Mahesh Kudale",
destination: "Nahur",
pickupDate: "01/12/2012",
    expectedDelivery: "11/12/2021",
    enrouteDays: "5",
    dateAdded: "01/02/2021"
  },
  {
    orderID: "125452",
    deliveryPartner: "BlueDart",
    awbNo: "1254",
currentStatus: "Dispatched",
custdetails: "Mahesh Kudale",
destination: "Nahur",
pickupDate: "01/12/2012",
    expectedDelivery: "11/12/2021",
    enrouteDays: "5",
    dateAdded: "01/02/2021"
  }
];
